/* global mzFunc, mzMenu, mzTabs */

import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import NavHelper from '../../../Helpers/navhelper';
import { openModal, scrollTo } from '../../../Helpers/helpers';
import GTMHelper from '../../../Helpers/gtmHelper';

import { Svg } from '../../1_Atoms/Svg/Svg';
import { updateLanguageLink } from '../../../utils';

export const Nav = ({ summaryCalculator = window.summaryCalculator, nav, ...props }) => {
    const { t, i18n } = useTranslation(['general', 'summary']);

    const { year, carline, trim, model, packageCode } = useParams();
    const [showFinancePrice, setShowFinancePrice] = React.useState(summaryCalculator.ShowFinancePrice);
    
    const gtmHelper = new GTMHelper();
    
    const navHelper = new NavHelper();
    const [step, setStep] = React.useState(summaryCalculator.CurrentStep)
    const [isOpen, setIsOpen] = React.useState(false);
    const [tabs, setTabs] = React.useState(nav != null ? nav.tabList : navHelper.getNavContent(t, true).tabList);
    const [activeTab, setActiveTab] = React.useState(tabs ?.filter(tab => tab.active === true)[0]);
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 1024);
    const navRef = React.useRef(null);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    React.useEffect(() => {
        try {
            // When Nav is re-mounted, run sticky submenu init function in Core
            // unless it's already processed by Core/menu.js .
            const isStickySubmenuProcessed = navRef.current.classList.contains('js-processed');
            if (!isStickySubmenuProcessed) {
                if (window.mzMenu && window.mzMenu.triggerStickySubmenu !== undefined) {
                    window.mzMenu.triggerStickySubmenu();
                }
            }
        } catch (err) {
            console.error(err)
        }
        if(typeof mzFunc === 'object' && typeof mzTabs === 'object'){
            mzFunc.waitForEl('.mzBuildandPrice nav .mz-tabs').then(function(components){
                mzTabs.init(components);
                setTimeout(()=>{
                    const subNav = document.querySelector('.App-container nav .mz-tabs-menu')
                    if(subNav)
                        mzTabs.adjustActiveTabPosition(subNav, subNav.querySelector('.active'));
                },500)
            });
        }
        reloadTabs();
    }, [nav])

    function reloadTabs() {
        //console.log('load data', nav)
        //if(summaryCalculator._allDataIsLoaded) setNav(navHelper.getNavContent(t)); // nav from parameter
        setTabs(nav != null ? nav.tabList : navHelper.getNavContent(t, true).tabList);
        setStep(summaryCalculator.CurrentStep);
    }


    React.useEffect(() => {
        reloadTabs();
    }, [summaryCalculator._allDataIsLoaded])

    React.useEffect(() => {
        reloadTabs();
        if(typeof mzMenu === 'object' && window.scrollY === 0){
            mzMenu.alertAni?.play();
            mzMenu.permAlertAni?.play();
            mzMenu.menuAni?.play();
        }
        //updateLanguageLink();
    }, [summaryCalculator.CurrentStep])

    function showNav() {
        //const selectVehiclesLinkLink = tabs;
        updateLanguageLink();
        
        const handleTabClick = (tabIndex) => {
            tabs.map(function (tab, index) {
                if (index === tabIndex) {
                    tab.active = true;


                } else {
                    tab.active = false;
                }
                return tab;
            });

            setTabs(tabs);
            setActiveTab(tabs.filter(tab => tab.active === true)[0]);
            if (isMobile) {
                if (isOpen) {
                    setIsOpen(false);
                    document.querySelector('body').classList.remove('disabled');
                } else {
                    setIsOpen(true);
                    document.querySelector('body').classList.add('disabled');
                }
            }

            if (tabs[tabIndex])
                navigate(tabs[tabIndex].uri);
            else // Gracefully recover to home /
                navigate('/');
            
            //HandleTabClick(tabs[tabIndex].uri)
        }
        const HandleClose = () => {
            setIsOpen(false);
            document.querySelector('body').classList.remove('disabled');
        }
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
            setIsOpen(false);
            document.querySelector('body').classList.remove('disabled');
        }

        window.addEventListener('resize', handleResize)

        const getCurrentActiveTabIndex = (tabs, activeTab) => {
            if (!tabs && !tabs.length > 0) return 0;
            return tabs.indexOf(activeTab) + 1;
        }

        function HandleSelectAVehicleClick(e) {
            e.preventDefault();
            document.querySelector('body').classList.remove('disabled');
            navigate(nav.selectVehiclesLinkLink.uri);
        }

        const handleOcaClick = (e) => {
            e.preventDefault();
            setIsOpen(false);
            document.querySelector('body').classList.remove('disabled');
            
            if (window.location.href.indexOf('/payments') > 0) {
                setSearchParams({'oca':''});
                setTimeout(() => {
                    setSearchParams({'oca':'1'});
                }, 10);
            }else{
                navigate(nav.tabList[6].uri + '&oca=1');
            }
            const price = summaryCalculator._showFinancePrice ? summaryCalculator.FinancialInfo.calculatedFinance.balanceToFinanceWithFeesWithRebatesTaxed : summaryCalculator.FinancialInfo.calculatedLease.balanceToLeaseWithFeesWithRebatesTaxed;
            gtmHelper.setGTM({'action':`OCA - Mobile Nav`,'year': year,'model': carline, 'trim': summaryCalculator.selectedVehicle.trim ?? summaryCalculator.AvailableTrim.trims[0].trim_type.url_slug, 'price' : Math.round(price)}, true, false);
        }

        return (
                <nav
                    className={isOpen ? 'mz-navigation mz-sticky-submenu mz-navigation__open' : 'mz-navigation mz-sticky-submenu'}
                    ref={navRef}
                    {...props}
                >
                    <div className="mz-container mz-navigation__wrapper">
                        <div className="mz-full-width mz-navigation__inner">
                            <div className="mz-navigation__reload">
                                <a className="mz-navigation__reload-link" onClick={(e) => {
                                    HandleSelectAVehicleClick(e);
                                }} >
                                    <Svg
                                        colour="grey"
                                        size={1.3}
                                        svg_list="refresharrow"
                                    />
                                    <span className="mz-navigation__reload-text" onClick={(e) => {
                                        HandleSelectAVehicleClick(e);
                                    }}>{nav !== null ? nav.selectVehiclesLinkLink.textDesktop : navHelper.getNavContent(t, true).selectVehiclesLinkLink.textDesktop}</span>
                                </a>
                            </div>
                            {!isMobile &&
                                <>
                                    <div className="mz-tabs">
                                        <div className="mz-tabs-menu">
                                            <div className="mz-tabs-menu-container">
                                                <div className="mz-tabs-menu-inner">
                                                    {tabs.map((tab, index) => {
                                                        return (<a key={index} role="tab" className={tab.active ? "mz-tabs-tab active nav--sm" : "mz-tabs-tab nav--sm"} onClick={() => handleTabClick(index)}>
                                                            {tab.text}
                                                        </a>)
                                                    })}
                                                </div>
                                                <div className="mz-tabs-menu--left"><i className="mz-svg mz-svg--grey mz-svg-chevron mz-svg--rotate180"></i></div>
                                                <div className="mz-tabs-menu--right"><i className="mz-svg mz-svg--grey mz-svg-chevron"></i></div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }

                            {isMobile &&
                                <><li role="tab" className="mz-navigation__navlist-tab mz-navigation__navlist-tab-close" onClick={() => HandleClose()}>
                                    {t("close")}
                                    <Svg
                                        colour="black"
                                        size={1}
                                        svg_list="chevron_small"
                                    />
                                </li>
                            
                                <ul className="mz-navigation__navlist">
                                    <li role="tab" className="mz-navigation__navlist-tab mz-navigation__navlist-tab-select-vehicle" onClick={(e) => HandleSelectAVehicleClick(e)}>{nav ?.selectVehiclesLinkLink ?.textMobile}
                                    </li>
                                    {tabs.map((tab, index) => {
                                        return (<li key={index} role="tab" className={tab.active ? "mz-navigation__navlist-tab mz-navigation__navlist-tab-selected" : "mz-navigation__navlist-tab"} onClick={() => handleTabClick(index)}>
                                            {tab.text}
                                            {tab.active ? <Svg
                                                colour="black"
                                                size={1}
                                                svg_list="chevron_small"
                                            /> : null}
                                        </li>);
                                    })
                                }
                                {window.allow_oca ?
                                <li className="mz-navigation__oca-tab" onClick={(e) => handleOcaClick(e)}  title={t('summary:btn_apply_for_financing')}>
                                    <div>
                                        <Svg
                                            colour="grey"
                                            size={1.2}
                                            svg_list="applytofinance"
                                        />
                                        <span>{ReactHtmlParser(t('general:ocaPriceBar'))}</span>
                                    </div>
                                </li>: null}
                            </ul>
                            </>}
                        </div>
                        <div className="mz-navigation__progress">
                            <div style={{ width: `${(getCurrentActiveTabIndex(tabs, activeTab) / nav ?.tabList ?.length) * 100}%` }}></div>
                        </div>
                    </div>
                </nav>
        );

    }
    return (<>{showNav()}</>)
};

// Nav.propTypes = {
//     HandleTabClick: PropTypes.func,
// }

// Nav.defaultProps = {
//     HandleTabClick: (uri) => {
//     },
// };